import { Redo2, Undo2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useCanvasMetadataSessionId } from "../../lib/schedule-art/canvas-state";
import { useHistoryStore } from "../../stores/history-store";
import { nextRedo, nextUndo } from "../../lib/schedule-history/app-history-actions";
import { describeMetadataAction } from "../history/describe-metadata-action";
import { Button } from "../ui/button";

export function MetadataHistoryButtons() {
  const { t } = useTranslation();
  const sessionId = useCanvasMetadataSessionId();
  const scope = { sessionId };
  const undoAction = useHistoryStore(state => nextUndo(state.events, state.undoneIds, scope));
  const redoAction = useHistoryStore(state => nextRedo(state.events, state.undoneIds, scope));
  const undo = useHistoryStore(state => state.undo);
  const redo = useHistoryStore(state => state.redo);
  const undoLabel = undoAction?.domain === "metadata" ? describeMetadataAction(undoAction.event, undoAction.target, t) : "";
  const redoLabel = redoAction?.domain === "metadata" ? describeMetadataAction(redoAction.event, redoAction.target, t) : "";

  return (
    <div className="ml-auto flex">
      <Button
        variant="ghost"
        size="icon-sm"
        title={`${t("metadata.history.undo")} ${undoLabel}`}
        disabled={!undoAction}
        onClick={() => undo(scope)}
      >
        <Undo2 />
      </Button>
      <Button
        variant="ghost"
        size="icon-sm"
        title={`${t("metadata.history.redo")} ${redoLabel}`}
        disabled={!redoAction}
        onClick={() => redo(scope)}
      >
        <Redo2 />
      </Button>
    </div>
  );
}
